import { ChatSession } from '../../../domain/chat/models/ChatSession';
import { ProviderServices } from '../../../services/chat/createProviderServices';

export interface DeleteChatSessionHandlerInput {
	session: ChatSession;
	accessToken: string;
	providerServices: ProviderServices;
}

export const deleteChatSessionHandler = async ({
	session,
	accessToken,
	providerServices,
}: DeleteChatSessionHandlerInput): Promise<void> => {
	const selectedProviderServices = providerServices.providerServicesRouter.getProviderServices(session.providerType);
	await selectedProviderServices.sessions.deleteChatAsync({ chatId: session.id }, accessToken);
};

export default deleteChatSessionHandler;
